import { EStatisticStoreOrderStatus, EStatisticStoreOrderStatusText } from 'entities/Statistic/Statistic.models';
import { EOrderRejectReason, EOrderRejectReasonText } from 'entities/Order/Order.models';

export const getOrderStatusText = (status: EStatisticStoreOrderStatus) => {
  switch (status) {
    case EStatisticStoreOrderStatus.PaymentAwaiting:
      return EStatisticStoreOrderStatusText.PaymentAwaiting;
    case EStatisticStoreOrderStatus.PaymentCancelled:
      return EStatisticStoreOrderStatusText.PaymentCancelled;
    case EStatisticStoreOrderStatus.New:
      return EStatisticStoreOrderStatusText.New;
    case EStatisticStoreOrderStatus.Preparing:
      return EStatisticStoreOrderStatusText.Preparing;
    case EStatisticStoreOrderStatus.Ready:
      return EStatisticStoreOrderStatusText.Ready;
    case EStatisticStoreOrderStatus.Completed:
      return EStatisticStoreOrderStatusText.Completed;
    case EStatisticStoreOrderStatus.CanceledByCustomer:
    case EStatisticStoreOrderStatus.CanceledByStore:
      return EStatisticStoreOrderStatusText.Canceled;

    default:
      return '-';
  }
};

export const rejectReasonText = (
  rejectReason: string,
  rejectDetails: string | null
): EOrderRejectReasonText | string => {
  switch (rejectReason) {
    case EOrderRejectReason.Abandoned:
      return EOrderRejectReasonText.Abandoned;

    case EOrderRejectReason.ChangeProduct:
      return EOrderRejectReasonText.ChangeProduct;

    case EOrderRejectReason.ChangeQuantity:
      return EOrderRejectReasonText.ChangeQuantity;

    case EOrderRejectReason.ChangeTime:
      return EOrderRejectReasonText.ChangeTime;

    case EOrderRejectReason.ProductsUnavailable:
      return EOrderRejectReasonText.ProductsUnavailable;

    case EOrderRejectReason.StoreTooBusy:
      return EOrderRejectReasonText.StoreTooBusy;

    case EOrderRejectReason.WaitedTooLong:
      return EOrderRejectReasonText.WaitedTooLong;

    case EOrderRejectReason.WrongLocation:
      return EOrderRejectReasonText.WrongLocation;
    case EOrderRejectReason.DeviceUnattended:
      return EOrderRejectReasonText.DeviceUnattended;

    default:
      return rejectDetails || 'Unknown reason';
  }
};
